import { ICartItem } from '~api/CartAPI/ICartAPIs';
import { SamplesController } from '~exported/samples-component/SamplesController';

import { diContainer } from './diContainer';
import { serviceNames } from './OffersService';

interface ICartUpdatedEvent {
    cart: {
        cartItems: ICartItem[];
    };
}

export default class ServiceBusController {
    public getManualOffer = async (offerCodes: string[]) => {
        const useCase = () => import('~use-cases/FetchedManualOffers');

        const { FetchedManualOffers } = await useCase();

        new FetchedManualOffers({ offerCodes }).execute();
    };

    public cartItemRemoved = async () => {
        const useCase = () => import('~use-cases/FetchAllViewsUseCase');

        const { FetchAllViewsUseCase } = await useCase();

        new FetchAllViewsUseCase().execute();
    };

    public cartUpdated = async (event?: ICartUpdatedEvent) => {
        const useCase = () => import('~use-cases/FetchAllViewsUseCase');

        const { FetchAllViewsUseCase } = await useCase();

        if (event && event.cart) {
            const controller: SamplesController = diContainer.get(serviceNames.samplesController);
            const samplesInCart = event.cart.cartItems?.filter(({ product }) => product.isSample);

            controller.cartRepository.setSamplesInCart(samplesInCart);
        }

        new FetchAllViewsUseCase().execute();
    };

    public cartOpened = async () => {
        const useCase = () => import('~use-cases/FetchAllViewsUseCase');

        const { FetchAllViewsUseCase } = await useCase();

        new FetchAllViewsUseCase().execute();
    };
}
